import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../../core/http.service';
import { environment } from '@base/environments/environment';
import { Observable, firstValueFrom } from 'rxjs';
import { Filter } from 'src/app/models/filters.model';

@Injectable({
  providedIn: 'root',
})
export class RrhhAgentService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/rrhh/agents';
    this.baseUrl = environment.apiEndpoint;
  }

  /*///////////////////////////////////////////////////////////

  • get() + id(agent) ⇒ DETALLE DE UN AGENTE
  
  • getAgentList() + id(oficina) + filtro ⇒ LISTA DE AGENTES

  • get() + id(agent) + '/canBeDisabled' ⇒ VALID. SI PUEDE DAR DE "BAJA QR" ESE AGENTE
  
  */ ///////////////////////////////////////////////////////////

  async getAgentList(
    id: string,
    currencyHeader: string,
    filter: Filter = new Filter()
  ): Promise<any> {
    try {
      const data = await firstValueFrom(
        this.getAgentListObservable(id, currencyHeader, filter)
      );
      return JSON.parse(JSON.stringify(data));
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  getAgentListObservable(
    id: string,
    currencyHeader: string,
    filter: Filter = new Filter()
  ): Observable<any> {
    const queryString = filter.toQueryString();

    const headers = new HttpHeaders().set('currency', currencyHeader);
    const options = { headers };

    return this.http.get(
      this.baseUrl + this.url + `/${id}?${queryString}`,
      options
    );
  }
}
